import { Block } from "@components/block";
import { ChartFilter } from "@components/chart-filter";
import { ProfitChart, ProfitFilterType } from "@components/profit-chart";
import { CustomSelect } from "@components/select";
import { formatRubles, formatUsdt } from "@helpers/format";
import classNames from "classnames";
import { FormProvider, useForm } from "react-hook-form";
import styles from "./transactions-info.module.scss";

interface Props {
  profit: number;
  className?: string;
  type?: "large" | "medium";
  formatType?: "usdt" | "rub";
}

export const TransactionsInfo = ({
  profit,
  className,
  type,
  formatType = "rub",
}: Props) => {
  const methods = useForm({
    defaultValues: {
      transactionType: "pay-in",
      filter: "week",
      cashRegister: null,
    },
  });
  const { control, watch, setValue } = methods;
  const transactionFilter = watch("transactionType");
  const filter = watch("filter");

  const options = [
    { text: "Pay-In", value: "pay-in" },
    { text: "Pay-Out", value: "pay-out" },
    { text: "Доход", value: "income" },
  ];

  const cashRegisters = [
    { text: "Касса №1", value: "cash-register-1" },
    { text: "Касса №2", value: "cash-register-2" },
    { text: "Касса №3", value: "cash-register-3" },
  ];

  return (
    <FormProvider {...methods}>
      <Block className={classNames(styles.card, className)}>
        <div className={styles.header}>
          <div className={styles.headerLeft}>
            <h3 className={styles.title}>
              {transactionFilter === "pay-in" && "Поступления"}
              {transactionFilter === "pay-out" && "Выплаты"}
              {transactionFilter === "income" && "Доход"}
            </h3>
            <p className={styles.profit}>
              {formatType == "rub" ? formatRubles(profit) : formatUsdt(profit)}
            </p>
          </div>

          <div className="flex gap-[12px]">
            <CustomSelect
              name="transactionType"
              control={control}
              options={options}
              placeholder="Выберите тип"
              styles={{ maxWidth: "160px" }}
              classNames={{
                trigger: "w-[160px]",
              }}
            />

            {type === "large" && (
              <CustomSelect
                name="cashRegister"
                control={control}
                options={cashRegisters}
                placeholder="Касса"
                styles={{ maxWidth: "160px" }}
                classNames={{
                  trigger: "w-[160px]",
                }}
              />
            )}

            <ChartFilter
              type={filter as ProfitFilterType}
              setType={(type) => setValue("filter", type)}
              className={styles.filter}
            />
          </div>
        </div>

        <ProfitChart type={filter as ProfitFilterType} />
      </Block>
    </FormProvider>
  );
};
